import { action } from 'typesafe-actions';
import { ILongSteelOrderItem } from '../long-steel-shopping-cart/types';
import { ILastOrder, Types } from './types';
import { RcFile } from 'antd/lib/upload';
import { ECodeType, IOrderEntryPreference } from '../user/types';

export const removeSearchedItem = (searchedItems: ILongSteelOrderItem[]) =>
  action(Types.REMOVE_SEARCHED_ITEM, { searchedItems });
export const addSearchedItem = (searchedItems: ILongSteelOrderItem[]) =>
  action(Types.ADD_SEARCHED_ITEM, { searchedItems });
export const cleanSearchItemErrors = () => action(Types.CLEAN_ERRORS);

export const searchItem = (
  customerId: string,
  searchTerm: string,
  codeType: ECodeType,
  customerState: string
) =>
  action(Types.SEARCH_ITEM, {
    customerId,
    searchTerm,
    codeType,
    customerState
  });
export const searchItemSuccess = (searchedItems: ILongSteelOrderItem[]) =>
  action(Types.SEARCH_ITEM_SUCCESS, { searchedItems });
export const searchItemFailure = (error: unknown) =>
  action(Types.SEARCH_ITEM_FAILURE, { error });

export const faceliftSearchItem = (
  customerId: string,
  searchTerm: string,
  codeType: ECodeType,
  customerState: string
) =>
  action(Types.FACELIFT_SEARCH_ITEM, {
    customerId,
    searchTerm,
    codeType,
    customerState
  });
export const faceliftSearchItemSuccess = (
  searchedItems: ILongSteelOrderItem[]
) => action(Types.FACELIFT_SEARCH_ITEM_SUCCESS, { searchedItems });
export const faceliftSearchItemFailure = (error: unknown) =>
  action(Types.FACELIFT_SEARCH_ITEM_FAILURE, { error });

export const spreadSheetMVP = (
  emitterId: string,
  codeType: ECodeType,
  file: RcFile,
  orderEntryPreference: IOrderEntryPreference,
  division: string[],
  customerState: string
) =>
  action(Types.SEARCH_ITEM_SPREADSHEET_MVP, {
    emitterId,
    codeType,
    file,
    orderEntryPreference,
    division,
    customerState
  });
export const cleanSpreadSheetMVP = () =>
  action(Types.CLEAN_ITEM_SPREADSHEET_MVP);
export const searchItemsSpreadsheet = (
  customerId: string,
  orderEntryPreference: IOrderEntryPreference,
  file: RcFile,
  customerState: string
) =>
  action(Types.SEARCH_ITEM_SPREADSHEET, {
    customerId,
    orderEntryPreference,
    file,
    customerState
  });
export const searchItemsSpreadsheetSuccess = (
  searchedItems: ILongSteelOrderItem[]
) => action(Types.SEARCH_ITEM_SPREADSHEET_SUCCESS, { searchedItems });
export const searchItemsSpreadsheetFailure = (error: unknown) =>
  action(Types.SEARCH_ITEM_SPREADSHEET_FAILURE, { error });
export const spreadsheetItemsExceeded = (isExceeded: boolean) =>
  action(Types.SPREADSHEET_ITEMS_EXCEEDED, { isExceeded });

export const loadLastOrders = (customerId: string) =>
  action(Types.LOAD_LAST_ORDERS, { customerId });
export const loadLastOrdersSuccess = (lastOrders: ILastOrder[]) =>
  action(Types.LOAD_LAST_ORDERS_SUCCESS, { lastOrders });
export const loadLastOrdersFailure = (error: unknown) =>
  action(Types.LOAD_LAST_ORDERS_FAILURE, { error });
export const cleanLastOrder = () => action(Types.CLEAN_LAST_ORDERS);

export const searchItemsFromLastOrder = (
  selectedLastOrder: ILastOrder,
  customerState: string
) =>
  action(Types.SEARCH_ITEMS_FROM_LAST_ORDER, {
    selectedLastOrder,
    customerState
  });
export const searchItemsFromLastOrderSuccess = (
  searchedItems: ILongSteelOrderItem[]
) => action(Types.SEARCH_ITEMS_FROM_LAST_ORDER_SUCCESS, { searchedItems });
export const searchItemsFromLastOrderFailure = (error: unknown) =>
  action(Types.SEARCH_ITEMS_FROM_LAST_ORDER_FAILURE, { error });
